import {remote} from '../constants/environment';
import {INotificationListResponse} from '../interfaces/services/notification-list-response.interface';
import {INotification} from '../interfaces/dtos/notification.interface';
import {defaultHeaders} from './headers';
import {customFetch as fetch, remoteCall} from '../utils/services';

export const getNotificationList = async (
  token: string,
  readed?: boolean,
): Promise<INotificationListResponse> => {
  const remoteURI = remote.getNotificationsListUri(readed);
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
          pragma: 'no-cache',
          'cache-control': 'no-cache',
        },
      });
    },
    async (response: Response) => {
      if (response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;
          return {
            success,
            payload: data.payload as INotification[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as INotificationListResponse;
};
